import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { ContractDatasource } from "@/shared/data/datasource/contract-datasource";
export var makeContractDatasource = function () {
    return new ContractDatasource(makeAuthorizeHttpClientDecorator());
};
